import React, { Component } from 'react';
import {connect} from 'react-redux';
import {cekCookies} from '../../../../../actions';
import __ from 'lodash';
import LoaderModal from '../../../../modal/LoaderModal';
import Navbar from '../../../navbar/Navbar';
import Sidebar from '../../../sidebar/Sidebar';
import { CONFIG } from '../../../../../config';
import accountManagement from '../../../../../apis/accountManagement';
import KelasSearch from '../../../../../entity/KelasSearch';
import KelasParalelSearch from '../../../../../entity/KelasParalelSearch';
import DropdownTahunAjaran from '../../masterDropDown/DropdownTahunAjaran';
import DropdownKelas from '../../masterDropDown/DropdownKelas';
import DropdownKelasParalel from '../../masterDropDown/DropdownKelasParalel';
import {Row, Col, Alert} from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Cookies from 'js-cookie';
import Dropdown from 'react-bootstrap/Dropdown'
import {ButtonGroup, Button} from '@material-ui/core';

class FilterTa extends Component {
    constructor(props) {
        super(props);
        this.state = {  
            isFetching: false,
            alertShow: false,            
            resMessage: '',
            ta: [],
            kelas: [],
            KelasParalelSearch: [],
            idKelasParalel: null,
            tipeCbt: 'AGCU',
            kodeAspek: 'TA',
            kodeTa: null,
            idKelas: null,
            idKp: null,
            idJadwal: null,
            idProfilCbt : null,
            jadwalCbt: [],
            kodeSubTipe:'',
            namaCbt:'',
        };
    }

    async componentDidMount() {         
        this.setState({ isFetching: true});
        await this.props.cekCookies();  
        
        if(!__.isEmpty(this.props.account)) {            
            this.fetchTa();
            this.fetchKelas();            
        } 
        this.setState({ isFetching: false});   
    }

    fetchTa = async () =>{
        //fetch tahun ajaran dulu
        const resTa = await accountManagement.get(CONFIG.ACCOUNT_MANAGEMENT_LIST_TAHUN_AJARAN).catch(function(error){
        })
        if(resTa){
            if(resTa.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE){
                this.setState({
                    ta: resTa.data.data
                })
                let kodeTa = null;
                resTa.data.data.map((val) =>{
                    if(val.status == "1"){
                        kodeTa = val.kodeTahunAjaran;
                        this.setState({kodeTa:val.kodeTahunAjaran})
                    }
                })
                this.fetchJadwal(this.state.idKelas, kodeTa);
            }
        }       

        
    }

    fetchKelas = async () =>{
        this.setState({isFetching: true});
        //fetch sekolah dulu
        const resSekolah = await accountManagement.get(CONFIG.ACCOUNT_MANAGEMENT_GET_SEKOLAH + this.props.account.idSekolah).catch(function(error){
        })
        let kodeJenjang = null;
        if(resSekolah){
            if(resSekolah.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE){
                kodeJenjang = resSekolah.data.data.kodeJenjangSekolah;               
            }
        }

        //fetch kelas setelah dapat data sekolah
        const response = await accountManagement.post(CONFIG.ACCOUNT_MANAGEMENT_SEARCH_KELAS, {KelasSearch, ["kodeJenjangSekolah"]: kodeJenjang}).catch(function(error){
        });
        // masukan data kelas ke dropdown
        if(response){
            if(response.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE){
                this.setState({
                    kelas: response.data.data
                })
            }
        }
        this.setState({isFetching: false});
    }
    
    fetchJadwal = async (idKelas, kodeTa) => {
        this.setState({isFetching: true, jadwalCbt:[]});
        const response = await accountManagement.get(CONFIG.GET_JADWAL_CBT_TA, {
            params: { 
                tahunAjaran: kodeTa, 
                idSekolah: this.props.account.idSekolah,
                idKelas: idKelas
            }
        }).catch (function(error){ console.log(error)}) 

        if(response) {
            if(response.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE){
                this.setState({
                    jadwalCbt: response.data.data
                })
            }
        }
        this.setState({isFetching: false});
    }

    hanldeOnChangeTa = async (e)=>{
        this.setState({kodeTa:e.target.value, jadwalCbt: []})
        this.fetchJadwal(this.state.idKelas, e.target.value);
    }

    handleOnChangeKelas = async (idKelas) => {
        this.setState({            
            idKelas: idKelas.target.value,
            jadwalCbt: [],
            idJadwal: null,
        })
        
        this.setState({isFetching: true});
        this.state.KelasParalelSearch=[];
        //fetch kelas pararelnya dulu
        const resKelasParalel = await accountManagement.post(CONFIG.ACCOUNT_MANAGEMENT_SEARCH_KELAS_PARALEL, {KelasParalelSearch,['idKelas']: idKelas.target.value, ['idSekolah']: this.props.account.idSekolah}).catch (function(error){
        })  

        // masukan kelas paralel ke  dropdown
        if(resKelasParalel){
            if(resKelasParalel.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE){
                this.setState({
                    KelasParalelSearch: resKelasParalel.data.data
                })
            }
        }

        if(this.state.kodeTa !== null) {
            this.fetchJadwal(this.state.idKelas, this.state.kodeTa);
        }
        this.setState({isFetching: false});
    }

    handleOnChangeKelasParalel = async (e) => {
        this.setState({
            idKelasParalel : e.target.value,
            renderSiswa:false
        })
        if(!__.isEmpty(e.target.value)){
            this.setState({            
                idKp: e.target.value
            })    
        }  

    }

    handleOnChangeJadwal = async (e) => {
        this.setState({renderSiswa:false})
        this.setState({ idJadwal: e.target.value })   

        this.state.jadwalCbt.map((val, i)=>{
            if(e.target.value == val.idJadwalCbt){
                this.setState({
                    idProfilCbt : val.idProfilCbt,
                    kodeSubTipe : val.kodeSubTipeCbt,
                    namaCbt : val.namaProfil
                })
                
            }
        })    
    }    

    handleClick(e) {  
        let idButton = e.target.id;
        if (idButton === 'btnSekolah'){   
            if(this.state.idJadwal === null) {
                alert('Pilih Profil CBT nya ya...');
                e.preventDefault();
            }         
        }
        if(idButton === 'btnKelas') {
            if(this.state.idJadwal === null && this.state.idKelas === null) {
                alert('Pilih Kelas & Profil CBT nya ya...');
                e.preventDefault();
            }
        }
        if(idButton === 'btnKelasP') {
            if(this.state.idJadwal === null && this.state.idKelasParalel === null) {
                alert('Pilih Kelas Paralel & Profil CBT nya ya...');
                e.preventDefault();
            }
        }
    }

    

    render() {
        const {jadwalCbt} = this.state;
        console.log('====================================');
        console.log(this.state);
        console.log('====================================');
        return (
            <div className="wrapper">
                <LoaderModal isFetching={this.state.isFetching}/> 
                <Sidebar account={this.props.account}/>
                <div id="content" style={{paddingBottom: '50px'}}>
                    <Navbar title={'Rekapitulasi Talent Analysis'}/> 
                    {this.loadAlert()}
                    <Row>                        
                        <Col sm={12}>
                            <Col><select className="form-control" value={this.state.kodeTa} onChange={this.hanldeOnChangeTa} required>
                                    <option value="" selected disabled>~~ Pilih Tahun Ajaran ~~</option>
                                    <DropdownTahunAjaran tahunAjaran={this.state.ta} />
                                </select>
                            </Col> 
                            <Col style={{marginTop:'10px'}}><select className="form-control" value={this.state.idKelas} onChange={this.handleOnChangeKelas} required>
                                    <option value="" selected disabled>~~ Pilih Kelas ~~</option>
                                    <DropdownKelas kelas={this.state.kelas} />
                                </select>
                            </Col>                            
                            <Col style={{marginTop:'10px'}}><select className="form-control" value={this.state.idKp} onChange={this.handleOnChangeKelasParalel}>
                                    <option value="" selected>~~ Pilih Kelas Paralel ~~</option>
                                    <DropdownKelasParalel kelasParalel={this.state.KelasParalelSearch} />
                                </select>
                            </Col>                              
                            <Col style={{marginTop:'10px'}}><select className="form-control" value={this.state.idJadwal} onChange={this.handleOnChangeJadwal} required>
                                <option value="" selected disabled>~~ Pilih CBT ~~</option>
                                {jadwalCbt.map(jadwal => 
                                    <option value={jadwal.idJadwalCbt}>{jadwal.namaJadwalCbt}</option>
                                )}
                                </select>
                            </Col>                             

                            <Col style={{marginTop:'15px'}}>
                                     
                                        <Row>
                                            <Col>
                                            {this.state.namaCbt.includes('KR -') ?
                                            <Link to={{ pathname: '/generate_rekap_ta/'+ this.state.idJadwal
                                                        +"/"+this.props.account.idSekolah
                                                        +"/"+null
                                                        +"/"+null
                                                        +"/"+this.state.kodeAspek }}
                                                onClick={(e) => this.handleClick(e)} target="_blank">
                                                <button className="btn btn-success btn-block" id="btnSekolah">Rekap Sekolah</button>
                                            </Link> :
                                            <Link to={{ pathname: '/generate_rekap_ta_sma/'+ this.state.idJadwal
                                                        +"/"+this.props.account.idSekolah
                                                        +"/"+null
                                                        +"/"+null
                                                        +"/"+this.state.kodeAspek }}
                                                onClick={(e) => this.handleClick(e)} target="_blank">
                                                <button className="btn btn-success btn-block" id="btnSekolah">Rekap Sekolah</button>
                                            </Link>
                                            }
                                            </Col>

                                            <Col>
                                            {this.state.namaCbt.includes('KR -') ?
                                            <Link to={{ pathname: '/generate_rekap_ta/'+ this.state.idJadwal
                                                    +"/"+this.props.account.idSekolah
                                                    +"/"+this.state.idKelas
                                                    +"/"+null
                                                    +"/"+this.state.kodeAspek }}
                                                onClick={(e) => this.handleClick(e)} target="_blank">
                                                <button className="btn btn-primary btn-block" id="btnKelas">Rekap Kelas</button>
                                            </Link>       :
                                             <Link to={{ pathname: '/generate_rekap_ta_sma/'+ this.state.idJadwal
                                                    +"/"+this.props.account.idSekolah
                                                    +"/"+this.state.idKelas
                                                    +"/"+null
                                                    +"/"+this.state.kodeAspek }}
                                                onClick={(e) => this.handleClick(e)} target="_blank">
                                                <button className="btn btn-primary btn-block" id="btnKelas" >Rekap Kelas</button>
                                            </Link>
                                            }                                        
                                            </Col>

                                            <Col>
                                            {this.state.namaCbt.includes('KR -') ?
                                            <Link to={{ pathname: '/generate_rekap_ta/'+ this.state.idJadwal
                                                    +"/"+this.props.account.idSekolah
                                                    +"/"+this.state.idKelas
                                                    +"/"+this.state.idKelasParalel
                                                    +"/"+this.state.kodeAspek }}
                                                onClick={(e) => this.handleClick(e)} target="_blank">
                                                <button className="btn btn-secondary btn-block" id="btnKelasP">Rekap Kelas Paralel</button>
                                            </Link>    :  
                                            <Link to={{ pathname: '/generate_rekap_ta_sma/'+ this.state.idJadwal
                                                    +"/"+this.props.account.idSekolah
                                                    +"/"+this.state.idKelas
                                                    +"/"+this.state.idKelasParalel
                                                    +"/"+this.state.kodeAspek }}
                                                onClick={(e) => this.handleClick(e)} target="_blank">
                                                <button className="btn btn-secondary btn-block" id="btnKelasP">Rekap Kelas Paralel</button>
                                            </Link>      
                                            }                                  
                                            </Col>
                                        </Row>          	                            
                            </Col>
                        </Col>

                                 
                    </Row>  


                </div>
            </div>
        );
    }
    loadAlert = () => {
        const {alertShow } = this.state;
      
        if (alertShow) {
          return (
            <Alert variant="info" onClose={() => this.setState({ alertShow: false })} dismissible>   
                <strong>{this.state.resMessage}</strong>
            </Alert>
          );
        } 
    } 
}

const mapStateToProps = (state) => {
    return{
        account: state.account       
    };
}

export default connect(mapStateToProps, {cekCookies})(FilterTa); 
